/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Agency = {

	delete (context, id, onSuccess, onError, options) {
		Api.delete(context,
			"/agency"
			+ "?id=" + id
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAll (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency/all"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCurrency (context, agencyId, onSuccess, onError, options) {
		Api.get(context,
			"/agency/currency"
			+ "?agencyId=" + agencyId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCurrencyCodeByAgency (context, agencyId, onSuccess, onError, options) {
		Api.get(context,
			"/agency/currency-code-by-agency"
			+ "?agencyId=" + agencyId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getMyCurrencyCode (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency/my-currency-code"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getName (context, agencyId, onSuccess, onError, options) {
		Api.get(context,
			"/agency/name"
			+ "?agencyId=" + agencyId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency/names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getNamesAndCountries (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency/names-and-countries"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUsers (context, agencyId, onSuccess, onError, options) {
		Api.get(context,
			"/agency/users"
			+ "?agencyId=" + agencyId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, agencyDTO, onSuccess, onError, options) {
		Api.post(context,
			"/agency"
			, agencyDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, agencyDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency"
			, agencyDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
